<script>
import cmrApi from '@/api/cmrApi';

export default {
    name: 'OrderNewAttachDialog',
    props: {
        open: { type: Boolean, required: true },
        selectedCmrList: { type: Array, required: true }
    },
    data() {
        return {
            file: null,
            loading: false,
            loadingResults: []
        }
    },
    methods: {
        onCloseDialog() {
            const withReload = Boolean(this.loadingResults.find(result => result.status === 'fulfilled'))
            this.$emit('onClose', withReload)
            this.loadingResults = []
            this.file = null
        },
        submitNewAttachment() {
            if (this.file instanceof File) {
                const reader = new FileReader()
                reader.onload = () => {
                    this.loading = true
                    const document = {
                        name: this.file.name,
                        file: reader.result.split(',')[1]
                    }

                    Promise.allSettled(this.selectedCmrList.map(cmr => this.uploadFile(cmr.id, document))).then(responses => {
                        this.loadingResults = responses.map((response, idx) => ({
                            cmrId: this.selectedCmrList[idx].id,
                            ...response
                        }))
                        this.loading = false
                    })
                }
                reader.onerror = () => {
                    this.file = null
                }
                reader.readAsDataURL(this.file)
            }
        },
        getResultStatus(id) {
            const result = this.loadingResults.find(result => result.cmrId === id)
            return result && result.status
        },
        getResultMessage(id) {
            if (this.loading) { return '' }

            const result = this.loadingResults.find(result => result.cmrId === id)
            if (!result) { return '' }

            switch (result.status) {
                case 'rejected':
                    return result.reason.response.data
                case 'fulfilled':
                    return this.$i18n.t('crm.attachFileSuccess')
                default:
                    return ''
            }
        },
        /**
         * @function uploadFile
         * @param cmrId {number}
         * @param document {{ name: string, file: string }
         * @return {Promise<void>}
         */
        uploadFile(cmrId, document) {
            return cmrApi.addDocument(cmrId, [document])
        }
    }
}
</script>

<template>
    <v-dialog :value="open" @input="onCloseDialog" width="600" :persistent="loading">
        <v-card v-if="!loading && !loadingResults.length" class="pt-5 pb-2 px-6">
            <v-file-input :label="$t('crm.uploadDocument')" v-model="file" />
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text @click="onCloseDialog">{{ $t('crm.cancel') }}</v-btn>
                <v-btn color="info" text @click="submitNewAttachment()">{{ $t('crm.save') }}</v-btn>
            </v-card-actions>
        </v-card>
        <v-card v-if="loading || loadingResults.length" class="pa-6">
            <v-expansion-panels>
                <v-expansion-panel
                    v-for="item in selectedCmrList"
                    :key="item.cmrCode"
                    :disabled="loading"
                >
                    <v-expansion-panel-header>
                        <div class="d-flex justify-lg-space-between">
                            {{ item.cmrCode }}
                            <v-progress-circular
                                v-if="loading"
                                :size="15"
                                color="primary"
                                indeterminate
                            />
                            <v-icon
                                v-if="!loading && getResultStatus(item.id) === 'fulfilled'"
                                small
                                color="green darken-2"
                            >
                                mdi-check-circle
                            </v-icon>
                            <v-icon
                                v-if="!loading && getResultStatus(item.id) === 'rejected'"
                                small
                                color="red darken-2"
                            >
                                mdi-alert-circle
                            </v-icon>
                        </div>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                        {{ !loading && getResultMessage(item.id) }}
                    </v-expansion-panel-content>
                </v-expansion-panel>
            </v-expansion-panels>
        </v-card>
    </v-dialog>
</template>
